import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AppState } from '../../../../app.reducer';
import { Store } from '@ngrx/store';
import { debounceTime, take } from "rxjs/operators";
import { GetFilesInMyFolder, DeleteFolder, GetMyFilesAndFolders, DeleteFile, DownloadDocument, GetCitisFolders } from "../_store/resources.actions";
import { FormControl } from "@angular/forms";
import { filterResults } from "../../../../app.constants";
import { ActivatedRoute, Router } from '@angular/router';
import { MoveFilesComponent } from '../move-files-dialogue/move-files.component'
import { NotificationModalComponent } from 'src/app/features/common-components/notification-modal/notification-modal.component';
import { ViewListService } from "../../../../services/list-grid-view.service";
import { MatTableDataSource } from '@angular/material';
import { RenameFolderDialogueComponent } from '../rename-folder-dialogue/rename-folder-dialogue.component';
import { LoaderHide, LoaderShow } from 'src/app/features/loader/store/loader.actions';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { PAGE_LIMIT } from 'src/app/app.constants';
import { CreateFolderComponent } from '../create-folder/create-folder.component';




@Component({
  selector: 'my-documents',
  templateUrl: './my-documents.component.html',
  styleUrls: ['./my-documents.component.scss']
})
export class MyDocumentsComponent implements OnInit {
  documentList: Array<any> = [];
  filteredDocuments: Array<any> = [];
  searchInput = new FormControl();
  folderList: Array<any> = [];       // stores list of folders or subfolders and files in the main folder
  showFilesInFolder: boolean = false; // flag to check whether listing all folders or files in main folder
  folderId: string;                  // stores currently opened folder id
  folderName: string;
  folderNavigationArr: Array<any> = [];                // stores currently opened folder name
  myFilesPageNumber: number = 1;
  myFilesPages: number = 0;
  myFoldersPageNumber: number = 1;
  myFoldersPages: number = 0;
  listView: boolean = false;
  isDataLoaded: boolean = false;
  dataSource: MatTableDataSource<any>
  dataDocSource: any;
  displayedColumns: string[] = ["Name", "Date", "Action"]
  displayedDocColumns: string[] = ["Name", "Date", "tags", "Action"]
  isdataloading: boolean = false;
  totalPages;
  currentPage;
  count
  sortOrder
  sortBy;

  limitPerPageOptions;
  pageSizeDefault = '30'
  pageSize = this.pageSizeDefault;

  @ViewChild('myDocsTable', { static: false })
  myDocsTable: any;
  currentUrl: string;
  isCitisFolder: boolean;
  isShowCitis: boolean;
  userId: any;
  citisFoldersList: any;
  citiisDataSource: MatTableDataSource<any>;

  constructor(
    private store: Store<AppState>,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    public router: Router,
    private viewData: ViewListService,
  ) {
    this.viewData.currentViewMode.subscribe(listViewFlag => this.listView = listViewFlag)
    this.currentUrl = this.router.url;
    // console.log(this.currentUrl);
    this.isCitisFolder = this.currentUrl.includes('citis');
    this.viewData.changeSortOptions('date', 'desc', +this.pageSize)
    this.viewData.CurrentSortBy.subscribe(sortBy => this.sortBy = sortBy)
    this.viewData.CurrentSortOrder.subscribe(sortOrder => this.sortOrder = sortOrder)

  }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  pageEvent: PageEvent;

  ngOnInit() {
    this.limitPerPageOptions = PAGE_LIMIT;
    
    // console.log(this.isCitisFolder)
    this.route.params.subscribe(param => {
      this.folderId = param.id
    })

    this.store.select(state => state.auth.user).pipe(
      take(1)
    ).subscribe(user => {
      if (user) {
        this.userId = user.details._id;
      }
    });

    if (this.folderId && this.router.url.includes('citis')) {
      this.isShowCitis = true;
    } else if (this.folderId && !this.router.url.includes('citis')) {
      this.isShowCitis = false;
    } else {
      const params = {
        page: this.myFilesPageNumber,
        limit: this.pageSize,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      }
      this.store.dispatch(new GetCitisFolders(params))
      this.isShowCitis = true;
    }

    this.folderList = []
    this.documentList = []
    this.filteredDocuments = [];

    /* listening to search input */
    this.searchInput.valueChanges.pipe(debounceTime(1000)).subscribe(searchString => {
      this.filteredDocuments = filterResults(this.documentList, searchString);
    });

    this.store.select(state => state.resources.myFilesAndFolders).pipe().subscribe(myFilesAndFolders => {
      this.isdataloading = false;
      this.pageSize = this.pageSizeDefault;

      this.store.dispatch(new LoaderHide());

      console.log(myFilesAndFolders);
      this.currentPage = myFilesAndFolders.details.page;
      this.totalPages = myFilesAndFolders.details.pages;
      this.count = myFilesAndFolders.details.total

      if (this.myDocsTable) {
        this.myDocsTable.nativeElement.scrollTop = 0;
      }

      // this.totalPages =  myFilesAndFolders.details.total;
      // this.currentPage = myFilesAndFolders.details.page;
      this.folderList = myFilesAndFolders['foldersList'];

      this.dataSource = new MatTableDataSource(this.folderList)
      this.filteredDocuments = myFilesAndFolders['filesList']
      this.dataDocSource = [...this.filteredDocuments];
      this.myFoldersPageNumber = myFilesAndFolders['details'].page;
      this.myFoldersPages = myFilesAndFolders['details'].pages;
      this.isDataLoaded = myFilesAndFolders.loaded;

      this.dataSource.paginator = this.paginator;
    });

    // invoke function to get all folders created by self
    if (this.folderId) {
      const params = {
        page: this.myFilesPageNumber,
        limit: this.pageSize,
        sortBy: this.sortBy,
        sortOrder: this.sortOrder
      }
      this.store.dispatch(new GetFilesInMyFolder(this.folderId, params));
      this.store.select(state => state.resources.filesInFolder).pipe().subscribe(folderContent => {
        // this.myFoldersPageNumber = folderContent.page;
        // this.myFoldersPages = folderContent.pages;
        this.currentPage = folderContent.page;
        this.totalPages = folderContent.pages;
        this.count = folderContent.total
        this.folderNavigationArr = (folderContent || {}).path || [];



        this.isdataloading = false;
        this.pageSize = this.pageSizeDefault;

        this.store.dispatch(new LoaderHide());
        this.folderList = []
        this.myFilesPages = (folderContent || {}).pages || 0;
        this.myFilesPageNumber = (folderContent || {}).page || 1;
        this.folderList = (folderContent || {}).subFoldersList || [];
        this.citisFoldersList = this.folderList;
        this.dataSource = new MatTableDataSource(this.folderList)
        this.citiisDataSource = new MatTableDataSource(this.folderList);
        this.filteredDocuments = (folderContent || {}).docsList || [];
        this.dataDocSource = [...this.filteredDocuments];

        this.folderName = folderContent.folderName;
        this.isDataLoaded = true;
        if (this.folderName) {
          this.getFilesInFolder(this.folderId, this.folderName, false)
        }
      });
    } else {
      this.getMyFilesAndFolders();
      this.getCitisFolders();
    }

    this.store.select(state => state.resources.deleteFolderRes).pipe().subscribe(response => {
      if (response['success']) {
        this.getMyFilesAndFolders();
      }
    });

  }
  getCitisFolders() {
    this.store.select(state => state.resources.citisFolders).pipe().subscribe(response => {
      
      this.citisFoldersList = response.folders;
      this.isdataloading = false;
      this.pageSize = this.pageSizeDefault;

      this.store.dispatch(new LoaderHide());
      this.citiisDataSource = new MatTableDataSource(this.citisFoldersList)
    });
  }

  canShowCitiis(){
    if (this.folderId && this.router.url.includes('citis')) {
      this.getCitisFolders();
      this.isShowCitis = true;
    } else if (this.folderId && !this.router.url.includes('citis')) {
      this.citisFoldersList = [];
      this.isShowCitis = false;
    } else {
      this.getCitisFolders();
      this.isShowCitis = true;
    }
    // return this.router.url.includes('citis')
  }

  isShowRename(folder){
    
    if( folder && this.checkPermissions('create-citiis-folder')){
      return true;
    }else{
      return false;
    }
  }

  isShowEditRoles(){
    if( this.checkPermissions('create-citiis-folder') && !this.router.url.includes('citis')){
      return true;
    }else{
      return false;
    }
  }

  getMyFilesAndFolders() {
    this.router.navigate(['/home/resources/me', '']);
    this.folderNavigationArr = [];
    this.showFilesInFolder = false;
    this.myFoldersPageNumber = 1;
    this.myFoldersPages = 0;
    this.isdataloading = true;
    this.store.dispatch(new LoaderShow());
    this.store.dispatch(new GetMyFilesAndFolders({ page: this.myFoldersPageNumber, limit: this.pageSize, 'sortOrder': this.sortOrder, 'sortBy': this.sortBy }));
    this.store.dispatch(new GetCitisFolders({ page: this.myFoldersPageNumber, limit: this.pageSize, 'sortOrder': this.sortOrder, 'sortBy': this.sortBy }))
    
  }

  /* 
      gets content of selected folder
      @param {folderId} id of the folder clicked on
  */
  getFilesInFolder(folderId, folderName, APIcallFlag?: boolean, isCitis = false) {
    this.isShowCitis = this.router.url.includes('citis');
    if (typeof folderId == "undefined") return;
    //this.router.navigate([], { queryParams: {} });
    // this.router.navigate([], { queryParams: { id: folderId } });
    if (APIcallFlag) {
      if (isCitis || this.isShowCitis) {
        this.router.navigate(['/home/resources/me/citis', folderId]);
      } else {
        this.router.navigate(['/home/resources/me', folderId]);
      }
    }


    this.showFilesInFolder = true;
    this.folderId = folderId;
    this.folderName = folderName;
    let clickedFolderIndex;

    // this.folderNavigationArr.push({ id: folderId, name: folderName });

    // this.folderNavigationArr.map((value, index) => {
    //   if (value.name == folderName) {
    //     clickedFolderIndex = index;
    //     this.folderNavigationArr.length = clickedFolderIndex + 1;  // increment by one to keep the current element.
    //   }
    // })
    /* reset myFilesPageNumber */
    this.myFilesPageNumber = 1;
    const params = {
      page: this.myFilesPageNumber,
      limit: this.pageSize,
      sortBy: this.sortBy,
      sortOrder: this.sortOrder
    }

    if (APIcallFlag) {
      this.store.dispatch(new GetFilesInMyFolder(folderId, params));

      this.isCitisFolder = this.currentUrl.includes('citis');

      this.store.select(state => state.resources.filesInFolder).pipe().subscribe(folderContent => {
        this.isdataloading = false;
        this.pageSize = this.pageSizeDefault;

        this.store.dispatch(new LoaderHide());
        this.folderList = []
        // set myFilesPageNumber and myFilesPages
        this.myFilesPages = (folderContent || {}).pages || 0;
        this.myFilesPageNumber = (folderContent || {}).page || 1;
        this.count = (folderContent || {}).total;
        this.folderList = (folderContent || {}).subFoldersList || [];
        this.dataSource = new MatTableDataSource(this.folderList)

        this.filteredDocuments = (folderContent || {}).docsList || [];
        this.dataDocSource = [...this.filteredDocuments];
        this.folderNavigationArr = (folderContent || {}).path || []
      });
    }
  }

  // showConfirmDeleteDialog() {
  //   let previousDeleteFolderIndex;  // to store index of the previos element i.e element before deleted element
  //   let previousDeleteFolderId;     // to store folder id of the previos element i.e element before deleted element

  //   const dialogRef = this.dialog.open(NotificationModalComponent, {
  //     width: '500px',
  //     panelClass: 'cmp-modal',
  //     data: {
  //       text: 'Are you sure you want to delete ? '
  //     }
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.store.dispatch(new DeleteFolder(this.folderId));
  //       this.store.select(state => state.resources.deleteFolderRes).pipe(take(1)).subscribe(response => {
  //         if (response['success']) {
  //           // folderNavigationArray maintains an array of opened folders.
  //           this.folderNavigationArr.map((value, index) => {
  //             // check for deleted folder name in the array
  //             if (value.name == this.folderName) {
  //               // get the index of element before deleted element
  //               previousDeleteFolderIndex = index - 1;
  //               // if index is 0 navigate to parent folder
  //               if (index == 0) {
  //                 this.getMyFilesAndFolders();
  //                 return;
  //               }
  //               // stores the folder id of previous element and navigate to that folder
  //               previousDeleteFolderId = this.folderNavigationArr[previousDeleteFolderIndex].id;
  //               document.getElementById("folder_" + previousDeleteFolderId).click();
  //               return;
  //             }
  //           })
  //         }
  //       })
  //     }
  //   });
  // }

  showMoveToFolderDialog(folderID: string = '', fileFlag: boolean = false) {
    // console.log("folderId", this.folderId);
    const dialogref = this.dialog.open(MoveFilesComponent, {
      hasBackdrop: true,
      width: '835px',
      panelClass: 'task-detail-modal',
      data: {
        fileId: folderID,
        Flag: fileFlag,
        currentFolderId: this.folderId
      }
    });
  }

  renameFolderDialog(folderObj) {
    const dialogref = this.dialog.open(RenameFolderDialogueComponent, {
      hasBackdrop: true,
      width: '700px',
      panelClass: 'task-detail-modal',
      data: {
        currentFolderObj: folderObj
      }
    });
  }

  editRoles(folderObj){
    console.log(folderObj)
    const dialogref = this.dialog.open(CreateFolderComponent, {
      hasBackdrop: true,
      width: '700px',
      panelClass: 'task-detail-modal',
      data: {
          alertTitle: 'Edit CITIIS Folder',
          folderIdParam: folderObj ? folderObj.folderId : '',
          folderObj: folderObj ? folderObj.id : '',
          isEditRoles:true,
          type: 'citiis'
      }
  })
  }

  canDelete(owner) {
    if ((this.userId == owner._id) && this.checkPermissions('remove-doc-citiis-folder')) {
      return false;
    } else {
      return false;
    }
  }

  checkPermissions(type) {
    let isAllow = false;
    this.store.select(state => state.auth.user['capabilities']).subscribe(response => {
      if (response.length) {
        const capabilities = (response || []).reduce((acc, item) => {
          return [...acc, ...item.capabilities];
        }, []);
        if (capabilities.includes(type)) {
          isAllow = true
        } else {
          isAllow = false;
        }
      }
    });
    return isAllow;
  }

  onScroll(event) {
    const divViewHeight = event.target.offsetHeight; // viewport: ~500px
    const divScrollHeight = event.target.scrollHeight; // length of all table
    const scrollLocation = event.target.scrollTop; // how far user scrolled
    const buffer = 0;
    const limit = divScrollHeight - divViewHeight - buffer;

    //for my messages
    if (scrollLocation >= limit) {
      if (!this.showFilesInFolder) {
        if (this.myFoldersPageNumber < this.myFoldersPages) {
          this.myFoldersPageNumber++;
          //   this.filteredDocuments = []   // commented this as it breaks pagination

          if (!this.isdataloading) {
            this.isdataloading = true;
            this.store.dispatch(new LoaderShow());
            this.store.dispatch(new GetMyFilesAndFolders({ 'page': this.myFoldersPageNumber, 'limit': this.pageSize }));
          }

        }
      } else {
        if (this.myFilesPageNumber < this.myFilesPages) {
          this.myFilesPageNumber++;
          if (!this.isdataloading) {
            this.isdataloading = true;
            this.store.dispatch(new LoaderShow);
            this.store.dispatch(new GetFilesInMyFolder(this.folderId, { 'page': this.myFilesPageNumber, 'limit': this.pageSize }));
          }
        }
      }
    }
  }

  showMoveToFolder() { }

  deleteFolderClicked(folder) {
    const dialogRef = this.dialog.open(NotificationModalComponent, {
      width: '500px',
      panelClass: 'cmp-modal',
      data: {
        text: 'Are you sure you want to delete this folder?'
      }
    });
    dialogRef.afterClosed().subscribe((response) => {
      if (response != undefined) {
        if (response) {
          this.store.dispatch(new DeleteFolder(folder.folderId, folder.parentId))
        }
      }
    });
  }

  uploadNewDocument() {
    this.router.navigate(['./home/resources/upload-document']);
  }

  openMoveDialogue(fileID: string = '', fileFlag: boolean = false) {
    const dialogRef = this.dialog.open(MoveFilesComponent, {
      width: '50%',
      panelClass: 'compose-mailbox',
      data: {
        fileId: fileID,
        Flag: fileFlag,
        currentFolderId: this.folderId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) { }
    });
  }

  onDocClick(document) {
    // console.log("on doc click")
    if (document) {
      if(this.isCitisFolder){
        this.router.navigate(['./home/resources/doc/'+ document._id +'/detail/citiis/'+this.folderId]);
      }else{
        this.router.navigate(['./home/resources/doc/' + document._id]);
      }
    }
  }

  deleteDoc(id) {
    const dialogRef = this.dialog.open(NotificationModalComponent, {
      width: '500px',
      panelClass: 'cmp-modal',
      data: {
          text: 'Are you sure you want to delete this document?'
      }
  });

  dialogRef.afterClosed().subscribe((response) => {
      if (response) {
          const payload = { isDeleted: true };
          this.store.dispatch(new DeleteFile(id, payload,this.folderId));
          // if (this.searchString.length) {
          //     setTimeout(() => { this.store.dispatch(new SearchDocuments(this.searchString, { page: 1, limit: 10 })); }, 1000)
          // }

      }
  });
  }

  downloadDocument(docObj) {
    this.store.dispatch(new DownloadDocument(docObj._id, docObj.fileName));
  }


  setPage(page) {
    // console.log(page);
    if (page <= this.totalPages) {
      this.store.dispatch(new LoaderShow);
      this.store.dispatch(new GetMyFilesAndFolders({ 'page': page, 'limit': 30, 'sortOrder': this.sortOrder, 'sortBy': this.sortBy }));
    }
  }

  getServerData(event?: PageEvent) {
    this.store.dispatch(new LoaderShow());
    if (this.folderId) {
      this.store.dispatch(new GetFilesInMyFolder(this.folderId, { 'page': event, 'limit': this.pageSize, 'sortOrder': this.sortOrder, 'sortBy': this.sortBy }));
    }
    else
      this.store.dispatch(new GetMyFilesAndFolders({ 'page': event, 'limit': this.pageSize, 'sortOrder': this.sortOrder, 'sortBy': this.sortBy }));
  }

  onChange(event) {
    this.viewData.changeSortOptions(this.sortBy, this.sortOrder, event.value)

    this.store.dispatch(new LoaderShow());
    if (this.folderId) {
      this.store.dispatch(new GetFilesInMyFolder(this.folderId, { 'page': 1, 'limit': event.value, 'sortOrder': this.sortOrder, 'sortBy': this.sortBy }));
    }
    else
      this.store.dispatch(new GetMyFilesAndFolders({ 'page': 1, 'limit': event.value, 'sortOrder': this.sortOrder, 'sortBy': this.sortBy }));
  }

  getActivityLog(){
    this.router.navigate(['/home/resources/citiis/activity-log/'+this.folderId]);
  }

  isShowButtons(document) {
    let ownerId = document.owner ? document.owner._id : '';
    this.store.select(state => state.auth.user).pipe(
        take(1)
      ).subscribe(user => {
        if (user) {
          this.userId = user.details._id;
        }
      });
    // if (this.checkPermissions('delete-doc')) {
        if (this.router.url.includes('citis')) {
            return (this.checkPermissions('remove-doc-citiis-folder') && (ownerId == this.userId));
        } else {
            return this.checkPermissions('delete-doc')
        }
    // } else {
    //     return false
    // }

}



}
